import {
  STOP_ACTION,
  START_ACTION,
  SET_ERROR,
  CREATE_NOTIFICATION,
  UPDATE_NOTIFICATIONS,
} from '../actionTypes/uiActionTypes';

const initialState = {
  loading: false,
  error: false,
  notificationsList: [],
};

const uiReducer = (state = initialState, action) => {
  switch (action.type) {
    case START_ACTION:
      return {
        ...state,
        loading: true,
      };
    case STOP_ACTION:
      return {
        ...state,
        loading: false,
      };
    case SET_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    case CREATE_NOTIFICATION:
      return {
        ...state,
        notificationsList: [...state.notificationsList, action.payload],
      };
    case UPDATE_NOTIFICATIONS:
      return {
        ...state,
        notificationsList: action.payload,
      };
    default:
      return state;
  }
};

export default uiReducer;
